
import {Vue, Component, Prop} from 'vue-property-decorator';
import {KanbanState} from "../kanban.model";
import {Board, Card, CardAttribute, CardAttributeDefinitionType, Ticket} from "../../backend/backendapi";
import AnswersModal from "../../survey/results/AnswersModal";

@Component({
  components: {AnswersModal}
})
export default class SurveyResultAttribute extends Vue {
  @Prop({required: true})
  readonly state!: KanbanState;
  @Prop({required: true})
  readonly board!: Board;
  @Prop({required: true})
  readonly card!: Card;

  get hasResults(): boolean {
    return !!this.surveyResult;
  }

  get surveyResult(): CardAttribute | undefined {
    if (this.board.attributeDefinitions?.length !== 1) {
      return undefined;
    }

    const def = this.board.attributeDefinitions[0];
    if (def.type === CardAttributeDefinitionType.SurveyResult) {
      const value = this.card.attributes?.find(a => a.definitionId === def.id)
      if (value) {
        return value;
      }
    }

    return undefined;
  }

  openSurveyResult(valueJson: string) {
    const parsedValue = JSON.parse(valueJson);
    if (parsedValue) {
      const surveyResultId = parsedValue.surveyResultId;
      const surveyId = parsedValue.surveyId;
      if (surveyId && surveyResultId) {
        (this.$refs.answerModal as AnswersModal).open(surveyId, surveyResultId);
      }
    }
  }
}
